const groupPrefix = createApiRoute(ApiModule.AUTH, ApiDataModel.TRANSACTIONS)
export const apiTransactions = {
	// eslint-disable-next-line max-params -- mock implementation, not yet connected to a real endpoint
	fetchTransactions: async (
		status: EOrderStatus[] | undefined,
		source: EOrderSource[] | undefined,
		calendar: string[] | undefined,
		dietType: EOrderDietType[] | undefined,
		diet: string[] | undefined,
		city: string[] | undefined,
		search: string | undefined,
		_page: number = 1,
		_perPage: number = 25,
	) =>
		await new Promise(resolve => {
			setTimeout(() => {
				resolve({
					meta: { total: 0 },
					data: [],
				})
			}, 1000)
		}),

	updateTransactionsStatus: async (ids: number[], status: EOrderStatus) => {
		const data = []
		ids.forEach(el => {
			data.push({ id: el, status })
		})

		return await new Promise(resolve => {
			setTimeout(() => {
				resolve({ data })
			}, 1000)
		})
	},

	createTransaction: async (transaction: IOrderModel) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}`, {
			method: 'POST',
			body: transactionToJSON(transaction),
		})
		return Order(data)

		// return await new Promise((resolve) => {
		// 	setTimeout(() => {
		// 		resolve(Order(transaction))
		// 	}, 1000)
		// })
	},
}
